export type FantasyMainTab =
    | "home"
    | "players"
    | "team"
    | "game";

export function getFantasyMainTab(
    pathname: string,
    leagueId: string
): FantasyMainTab | undefined {
    if (!leagueId) {
        return undefined;
    }

    if (
        pathname.startsWith(
            `/fantasyLeague/${leagueId}`
        )
    ) {
        return "home";
    }

    if (
        pathname.startsWith(
            `/fantasyPlayers/${leagueId}`
        ) ||
        pathname.startsWith(
            `/fantasyDropPlayers/${leagueId}`
        ) ||
        pathname.startsWith(
            `/fantasyTopPlayers/${leagueId}`
        )
    ) {
        return "players";
    }

    if (
        pathname.startsWith(
            `/fantasyTeam/${leagueId}`
        )
    ) {
        return "team";
    }

    if (
        pathname.startsWith(
            `/fantasyGame/${leagueId}`
        )
    ) {
        return "game";
    }

    return undefined;
}

export function getFantasyMainTabPath(
    tab: FantasyMainTab,
    leagueId: string
): string {
    switch (tab) {
        case "home":
            return `/fantasyLeague/${leagueId}`;

        case "players":
            return `/fantasyPlayers/${leagueId}`;

        case "team":
            return `/fantasyTeam/${leagueId}`;

        case "game":
            return `/fantasyGame/${leagueId}`;
    }
}

export function getFantasyPlayersSubmenuPath(
    tab: "add" | "drop" | "leaders",
    leagueId: string
): string {
    switch (tab) {
        case "drop":
            return `/fantasyDropPlayers/${leagueId}`;

        case "leaders":
            return `/fantasyTopPlayers/${leagueId}`;

        default:
            return `/fantasyPlayers/${leagueId}`;
    }
}

export function isFantasyMainTab(
    value: string
): value is FantasyMainTab {
    return [
        "home",
        "players",
        "team",
        "game"
    ].includes(value);
}
